// extracted by mini-css-extract-plugin
export default {"incorrectChoice":"ChoiceUserInputActionContent_incorrectChoice__6CaU3","phraseDiv":"ChoiceUserInputActionContent_phraseDiv__WLaPQ"};